export enum StatusCheck {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
}
